import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ReferralsInfoMessage = {
  balance: number
  code: string
  referred_fan_count: number
  referred_creator_count: number
}

interface ReferralsInfoCacheState {
  message: ReferralsInfoMessage | null
  setMessage: (message: ReferralsInfoMessage) => void
  clear: () => void
}

export const useReferralsInfoCacheStore = create<ReferralsInfoCacheState>()(
  persist(
    (set) => ({
      message: null,
      setMessage: (message) => set({ message }),
      clear: () => set({ message: null }),
    }),
    {
      name: 'referrals-info-cache-v1',
      partialize: (state) => ({ message: state.message }),
    }
  )
)